import type { QuestionVisibility, SurveyForm, SurveyPart, SurveyQuestion } from '../../../../extViewmodels';

/**
 * The BE returns sectioned (V2) surveys with nested `SurveySection` parts in
 * `surveyForm.surveyParts`, but the generated SDK models are stale and only
 * model flat `SurveyPart`/`SurveyQuestion`. This local augmentation describes
 * the real runtime shape for the respondent + preview render path.
 *
 * Verified against Levitate-API origin/master 2026-06-01 (SurveyForm.cs /
 * Api.Models/Surveys/Survey.cs): _type discriminator "SurveySection" with
 * title, description, nested questions[], and a section-level visibleWhen.
 */
export interface SurveySection extends SurveyPart {
	_type: 'SurveySection';
	title?: string;
	description?: string;
	questions?: SurveyQuestion[];
	visibleWhen?: QuestionVisibility | null;
}

/** Narrow a SurveyPart to a SurveySection. */
export const isSurveySection = (part: SurveyPart | undefined | null): part is SurveySection =>
	part?._type === 'SurveySection';

/** A surveyForm whose parts may include nested SurveySection containers. */
export type SectionedSurveyForm = Omit<SurveyForm, 'surveyParts'> & {
	surveyParts: Array<SurveyPart | SurveySection>;
};
